export const userRecipePrompt = (prompt) => `
Analyze the user's input and follow these rules:

user input: ${prompt}

 The first rule is: 
  Try to understand the user's input and make a recipe based on it or what really user want to see.

  The second rule is:
  If the input is not food-related, provocative, nonsensical, or contains profanity, 
   return JSON in format:
   {
     "errorMessage": "<short, sarcastic, witty response to incorrect input be toxic on his input>"
   }

  The third rule is:
  If the input describes food or ingredients: 
   Generate exactly ONE (1) unique, nutritionally balanced, safe-to-eat, and well-paired home-cooking recipe based on this dish:
 
   - Provide a realistic "cooktime" in minutes and "calories" estimate.
- "level" must be either "Easy" or "Medium."

- The recipe must include an "aidescription" (100 characters) with a cinematic editorial focus on the final plated dish:
  * Emphasize how ingredients are arranged (layering, drizzle, garnish).
  * Mention vivid colors, subtle steam or sauce details.
  * Use a warm, softly blurred background (aligned with the purple palette) shot on a ~70mm lens at shallow depth of field (f/3.5).
  * Crisp, photoreal texture with fresh details, no extra props or text overlays.
  * This aidescription guides an AI image model to create a professional food photo.

 
Return as a valid JSON array with EXACTLY one object:
[
  {
    "title": "dish name max 15-18 characters",
    "usedIngredients":[ array with emoji and ingredient name e.x "🍅 tomato", "🥛 milk", "🍞 bread" ], // max 3 ingredients and all of them in emoji + 1 word 
    "img": null,
    "cooktime": number,
    "calories": number,
    "level": "Easy" or "Medium",
    "aidescription": "a 100 char text describing final plating..."
  }
]
`.trim();

